function AppFooterCopyright() {
	return (
		<div className="font-general-regular flex justify-center items-center text-center">
			<div className="text-lg text-ternary-dark dark:text-ternary-light">
				&copy; Esther Mugami - Protecting your assets and investments with personalized insurance solutions.
				<a
					href="https://github.com/realstoman/react-tailwindcss-portfolio"
					target="__blank"
					className="hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 ml-1 duration-500"
				>
					
				</a>
				<p className="pt-10 text-sm">
				Website design by
				<a
					href="mailto:lusenakalee@gmail.com"
					target="__blank"
					className="text-secondary-dark dark:text-secondary-light font-medium uppercase hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 ml-1 duration-500"
				>
					 Leroy Lusenaka
				</a>
				</p>
			</div>
		</div>
	);
}

export default AppFooterCopyright;